import { render } from "./OrdersModal.vue?vue&type=template&id=21f2cf66&scoped=true"
import script from "./OrdersModal.vue?vue&type=script&lang=js"
export * from "./OrdersModal.vue?vue&type=script&lang=js"

import "./OrdersModal.vue?vue&type=style&index=0&id=21f2cf66&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f2cf66"]])

export default __exports__